import React from 'react';
import CardsBodyWrapper from '../CardsBodyWrapper';
import { QuoteContainer, AuthorContainer, FooterPercentContainer } from './styles';

const StatCard = props => {
  const { description, author, percent } = props;
  return (
    <div
      data-testid="card-body-wrapper"
      role="listitem"
      className={`card--body-wrapper ${percent ? 'with-footer-percent' : ''}`}
    >
      {description && (
        <QuoteContainer>
          <p>“{description}”</p>
        </QuoteContainer>
      )}
      {author && (
        <AuthorContainer>
          <p>{author}</p>
        </AuthorContainer>
      )}
      {percent && <FooterPercent percent={percent} />}
    </div>
  );
};

export default CardsBodyWrapper(StatCard);

const FooterPercent = ({ percent }) => (
  <FooterPercentContainer>
    <div className="footer-percent--percent">
      <p>{percent}</p>
      <svg
        width="17"
        height="15"
        viewBox="0 0 17 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8.5 0L16.7272 14.25H0.272758L8.5 0Z" fill="#CFD8DC" />
      </svg>
    </div>

    <p className="footer-percent--description">Increase in revenue in one year</p>
  </FooterPercentContainer>
);
